import React, { useState, useEffect } from 'react';
import GraficaAirTemperature from './GraficaAirTemperature';import GraficaAirHumidity from './GraficaAirHumidity';
import GraficaSoilHumidityPercentage from './GraficaSoilHumidityPercentage';
import GraficaSoilHumidityCB from './GraficaSoilHumidityCB';
import useGetSoilSensors from '../../hooks/useGetSoilSensors';
import './SoilSensorDashboard.css';

const SoilSensorDashboard = ({ soilSensorId: initialSoilSensorId }) => {
  const { soilSensors, loading, error } = useGetSoilSensors();
  const [selectedSoilSensor, setSelectedSoilSensor] = useState(initialSoilSensorId || '');
  const defaultStart = new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString();
  const defaultEnd = new Date().toISOString();
  const [start, setStart] = useState(defaultStart);
  const [end, setEnd] = useState(defaultEnd);

  const MAX_RANGE_DAYS = 60;
  const MAX_RANGE_MS = MAX_RANGE_DAYS * 24 * 60 * 60 * 1000;

  const validateRange = (newStart, newEnd) => {
    const startDate = new Date(newStart);
    const endDate = new Date(newEnd);
    if (startDate > endDate) return false;
    if (endDate - startDate > MAX_RANGE_MS) return false;
    return true;
  };

  const handleStartChange = (value) => {
    const iso = new Date(value).toISOString();
    if (validateRange(iso, end)) {
      setStart(iso);
    } else {
      alert(`El intervalo máximo permitido es de ${MAX_RANGE_DAYS} días`);
    }
  };

  const handleEndChange = (value) => {
    const iso = new Date(value).toISOString();
    if (validateRange(start, iso)) {
      setEnd(iso);
    } else {
      alert(`El intervalo máximo permitido es de ${MAX_RANGE_DAYS} días`);
    }
  };

  useEffect(() => {
    if (soilSensors.length && !selectedSoilSensor) {
      setSelectedSoilSensor(soilSensors[0].soilSensorId);
    }
  }, [soilSensors, selectedSoilSensor]);

  if (loading) return <p>Cargando estaciones...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!selectedSoilSensor) return <p>Selecciona una estación para continuar</p>;

  return (
    <div className="soil-sensor-dashboard">
      <div className="dashboard-header">
        <h2>
          {soilSensors.length > 0 && selectedSoilSensor && (
          <span style={{ fontSize: '28px' }}>
            {soilSensors.find(s => s.soilSensorId === selectedSoilSensor)?.location.name}
          </span>
        )}

        </h2>

        <div className="time-range-selector">
          <label>
            Inicio:
            <input
              type="datetime-local"
              value={start.slice(0, 16)}
              onChange={(e) => handleStartChange(e.target.value)}
            />
          </label>

          <label>
            Fin:
            <input
              type="datetime-local"
              value={end.slice(0, 16)}
              onChange={(e) => handleEndChange(e.target.value)}
            />
          </label>
        </div>

        <select
          value={selectedSoilSensor}
          onChange={(e) => setSelectedSoilSensor(e.target.value)}
          className="soilSensor-selector"
        >
          {soilSensors.map((soilSensor) => (
            <option key={soilSensor.soilSensorId} value={soilSensor.soilSensorId}>
              {soilSensor.location.name}
            </option>
          ))}
        </select>
      </div>

      <div className="dashboard-grid">
        <GraficaAirTemperature soilSensorId={selectedSoilSensor} start={start} end={end} />
        <GraficaAirHumidity soilSensorId={selectedSoilSensor} start={start} end={end} />
        <GraficaSoilHumidityPercentage soilSensorId={selectedSoilSensor} start={start} end={end} />
        <GraficaSoilHumidityCB soilSensorId={selectedSoilSensor} start={start} end={end} />
      </div>
    </div>
  );
};

export default SoilSensorDashboard;
